export const floatingActions = {
	massEdit: "Édition en masse des produits",
	editExcel: "Éditer via Excel",
	testFiscal: "Tester l'intégration fiscale",
	syncWithDelivery: "Synchroniser avec la livraison",
	deleteSelected: "Supprimer les produits sélectionnés",
};
